// JS of sticky add to cart button on mobile

let stickyInitialized = false;

function initStickyATC() {
  // prevent double init
  if (stickyInitialized) return;
  if (window.innerWidth > 768) return;

  const sticky = document.getElementById("sticky-atc");
  if (!sticky) return;

  stickyInitialized = true;

  const sizeSelect = sticky.querySelector("[data-size-select]");
const addBtn = sticky.querySelector("[data-add-to-cart]");
const notifyBtn = sticky.querySelector("[data-notify-when-available]");
const colorLabel = sticky.querySelector("[data-sticky-color]");

/* =============================
   NOTIFY-ONLY PRODUCT
============================= */
if (notifyBtn) {
  // Show the sticky bar normally.
  sticky.classList.add("is-visible");

  // Get selected color from the main product form
  const productForm = document.querySelector(".product-form");
  const colorInputs = productForm?.querySelectorAll(
    'input[data-option="Color"]'
  );

  const selectedColor = colorInputs
    ? [...colorInputs].find(input => input.checked)?.value
    : null;

  if (colorLabel) {
  if (selectedColor) {
    colorLabel.textContent = `Color: ${selectedColor}`;
  } else {
    colorLabel.style.display = "none";
  }
}
notifyBtn.addEventListener("click", () => {
  notifyBtn.textContent = "OPENING…";
  notifyBtn.classList.add("is-loading");

  window.omnisend = window.omnisend || [];
  window.omnisend.push([
    "openForm",
    "6ac69a86b5ffbd3d2a448328"
  ]);

  setTimeout(() => {
    notifyBtn.textContent = "NOTIFY WHEN AVAILABLE";
    notifyBtn.classList.remove("is-loading");
  }, 1000);
});
  // Stop normal ATC initialization.
  return;
}

// Safety check for normal products
if (!sizeSelect || !addBtn) return;

// Subtle Shop Pay installment message below sticky ATC
if (!sticky.querySelector(".sticky-atc__installments")) {
  const installmentText = document.createElement("div");

  installmentText.className = "sticky-atc__installments";
  installmentText.textContent = "Pay in 4 installments with Shop Pay";

  addBtn.insertAdjacentElement("afterend", installmentText);
}
  const variants = JSON.parse(
    sticky.querySelector(".sticky-variant-json").textContent
  );

  const productForm = document.querySelector(".product-form");
  const colorInputs = productForm?.querySelectorAll(
    'input[data-option="Color"]'
  );

  /* =============================
  /* Always show sticky ATC while on mobile PDP */
sticky.classList.add("is-visible");
  /* =============================
     HIDE STICKY WHEN CART DRAWER OPENS
     Works with Kaching Cart drawer
  ============================= */
  function hideSticky() {
    sticky.style.setProperty("display", "none", "important");
  }

  function showSticky() {
    sticky.style.removeProperty("display");
  }

  // Watch for Kaching cart drawer opening/closing via class on body or the drawer element
  const cartDrawerObserver = new MutationObserver(() => {
    // Kaching Cart adds classes like 'kaching-cart-open' or 'is-open' to its drawer
    const kachingDrawer =
      document.querySelector(".kaching-cart-drawer") ||
      document.querySelector("[class*='kaching'][class*='open']") ||
      document.querySelector("[id*='kaching']");

    const isKachingOpen =
      document.body.classList.contains("kaching-cart-open") ||
      document.body.classList.contains("cart-is-open") ||
      document.documentElement.classList.contains("kaching-cart-open") ||
      (kachingDrawer &&
        (kachingDrawer.classList.contains("is-open") ||
          kachingDrawer.classList.contains("open") ||
          kachingDrawer.getAttribute("aria-hidden") === "false"));

    if (isKachingOpen) {
      hideSticky();
    } else {
      showSticky();
    }
  });

  // Observe body and html for class changes (Kaching toggles classes here when drawer opens)
  cartDrawerObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ["class", "style"]
  });
  cartDrawerObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class", "style"]
  });

  // Also observe the Kaching drawer element itself if it exists in the DOM
  const kachingRoot = document.querySelector(
    "[class*='kaching'], [id*='kaching']"
  );
  if (kachingRoot) {
    cartDrawerObserver.observe(kachingRoot, {
      attributes: true,
      attributeFilter: ["class", "aria-hidden", "style"]
    });
  }

  // Show sticky again when user taps outside / closes the drawer
  document.addEventListener("click", (e) => {
    // If clicking outside the kaching drawer, restore sticky
    const kachingDrawer = document.querySelector(
      "[class*='kaching-cart'], [id*='kaching-cart']"
    );
    if (kachingDrawer && !kachingDrawer.contains(e.target)) {
      setTimeout(showSticky, 300);
    }
  });

  /* =============================
     COLOR SYNC
  ============================= */
  function updateColor() {
    const selected = [...colorInputs].find(i => i.checked);
    colorLabel.textContent = selected
      ? `Color: ${selected.value}`
      : "Color: —";
  }

  /* =============================
     SIZE + AVAILABILITY CHECK
  ============================= */
  function updateButtonState() {
  const size = sizeSelect.value;
  const color = colorInputs
    ? [...colorInputs].find(i => i.checked)?.value
    : null;

  // No size selected
if (!size) {
  addBtn.textContent = "ADD TO CART";

  // Keep CTA active-looking so click can trigger size error
  addBtn.disabled = false;
  addBtn.classList.remove("is-disabled");

  return;
}

// Show selected size in the size selector
  const variant = variants.find(v =>
    v.available &&
    v.options.includes(size) &&
    (!color || v.options.includes(color))
  );

  if (!variant) {
    addBtn.textContent = "SOLD OUT";
    addBtn.disabled = true;
    addBtn.classList.add("is-disabled");
  } else {
    addBtn.textContent = "ADD TO CART";
    addBtn.disabled = false;
    addBtn.classList.remove("is-disabled");
  }
}

  /* =============================
     ADD TO CART
  ============================= */
  addBtn.addEventListener("click", () => {
  const size = sizeSelect.value;

  // No size selected — show error state, do not add to cart
  if (!size) {
    sticky.classList.add("has-size-error");

    return;
  }

  // Clear error once a size exists
  sticky.classList.remove("has-size-error");

  const color = colorInputs
    ? [...colorInputs].find(i => i.checked)?.value
    : null;

  const variant = variants.find(v =>
    v.available &&
    v.options.includes(size) &&
    (!color || v.options.includes(color))
  );

  if (!variant) return;

    addBtn.classList.add("is-loading");
    addBtn.textContent = "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variant.id,
        quantity: 1
      })
    })
      .then(() => {
        const cartBtn = document.querySelector(".js-header-cart-toggler");
        const discountBtn = document.querySelector(
          ".js-cart-discount-apply-button"
        );

        if (cartBtn) cartBtn.click();
        if (discountBtn) discountBtn.click();
      })
      .finally(() => {
        addBtn.classList.remove("is-loading");
        addBtn.textContent = "Add to cart";
      });
  });

  /* =============================
     LISTENERS
  ============================= */
  sizeSelect.addEventListener("change", () => {
  sticky.classList.remove("has-size-error");
  updateButtonState();
});

productForm?.addEventListener("change", () => {
  updateColor();
  updateButtonState();
});

  updateColor();
  updateButtonState();
}

/* Init on load */
document.addEventListener("DOMContentLoaded", initStickyATC);

/* Init when switching to mobile via DevTools */
window.addEventListener("resize", initStickyATC);

/* =============================
   MAIN PRODUCT NOTIFY BUTTON
============================= */

document.addEventListener("click", (event) => {
  const notifyButton = event.target.closest(
    ".product-form [data-notify-when-available]"
  );

  if (!notifyButton) return;

  notifyButton.textContent = "OPENING…";
  notifyButton.classList.add("is-loading");

  window.omnisend = window.omnisend || [];
  window.omnisend.push([
    "openForm",
    "6ac69a86b5ffbd3d2a448328"
  ]);

  setTimeout(() => {
    notifyButton.textContent = "NOTIFY WHEN AVAILABLE";
    notifyButton.classList.remove("is-loading");
  }, 1000);
});
